import { ListItemButton, Typography } from '@mui/material';

import { getPatients } from 'apis/admin';
import usePatient from 'store/patient/usePatient';
import MuiAutocomplete from 'components/MuiAutocomplete';

import { ReactComponent as Cookie } from 'assets/alarm-icon.svg';
import { ReactComponent as Empty } from 'assets/alarm-icon-empty.svg';

interface IOption {
  patient_id: string;
  name: string;
  age: string;
  has_nursing_record?: boolean;
  hasNursingRecord?: boolean;
  nursing_record_count?: number;
  nursingRecordCount?: number;
  nursing_records?: unknown[];
}

interface Props {
  user_id: number;
}

const PatientsList = ({ user_id }: Props) => {
  const { onSelectedPatient } = usePatient();

  const optionLabel = ({ patient_id, name }: IOption) =>
    `${patient_id} ${name}`;

  const hasNursingRecord = (option: IOption) => {
    return (
      !!option.has_nursing_record ||
      !!option.hasNursingRecord ||
      Number(option.nursing_record_count ?? option.nursingRecordCount ?? 0) > 0 ||
      (Array.isArray(option.nursing_records) && option.nursing_records.length > 0)
    );
  };

  const Option = ({
    optionProps,
    option,
  }: {
    optionProps: any;
    option: IOption;
  }) => {
    const { patient_id, name, age } = option;

    if (!hasNursingRecord(option)) {
      return (
        <ListItemButton {...optionProps} sx={{ gap: 0.2 }}>
          <Empty />
          <Typography
            variant="subtitle2"
            fontSize="14px"
            sx={{ whiteSpace: 'nowrap' }}
          >
            {patient_id}
          </Typography>
          <Typography variant="caption" fontSize="14px" color={'#000000B2'}>
            {name}
          </Typography>
          <Typography
            variant="caption"
            fontSize="14px"
            color={'#000000B2'}
            sx={{ whiteSpace: 'nowrap' }}
          >
            {age}
          </Typography>
        </ListItemButton>
      );
    } else {
      return (
        <ListItemButton {...optionProps} sx={{ gap: 0.2 }}>
          <Cookie />
          <Typography
            variant="subtitle2"
            fontSize="14px"
            sx={{ whiteSpace: 'nowrap' }}
          >
            {patient_id}
          </Typography>
          <Typography variant="caption" fontSize="14px" color={'#000000B2'}>
            {name}
          </Typography>
          <Typography
            variant="caption"
            fontSize="14px"
            color={'#000000B2'}
            sx={{ whiteSpace: 'nowrap' }}
          >
            {age}
          </Typography>
        </ListItemButton>
      );
    }
  };

  return (
    <MuiAutocomplete
      variant="standard"
      valueKey="patient_id"
      listKey="admin_patients"
      placeholder="Patient Search"
      noOptionsText="No patient found. Please enter another patient name"
      getOptionLabel={optionLabel}
      renderOption={(props, option) => {
        if (!user_id) {
          return null;
        } else return <Option optionProps={props} option={option} />;
      }}
      onChange={onSelectedPatient}
      getApi={params => getPatients({ ...params, user_id })}
    />
  );
};

export default PatientsList;
